import React, { Fragment, useState } from 'react';
import { toast } from 'react-toastify';
import { PropTypes } from 'prop-types';
import { Styles, Icon } from '@contently/toolkit';
import styled from '@emotion/styled';

const CsvDownloadBox = styled('div')`
  border: 1px solid #d4d4d4;
  padding: 2px 0;
  margin-top: ${props => props.margin};
  position: absolute;
  width: 125px;
  z-index: 1;
  &:hover {
    background-color: ${Styles.colors.blue.secondary};
    cursor: pointer;
  }
  a {
    text-decoration: none;
  }
`;

const CsvDownloadText = styled('a')`
  padding: 0.5rem;
  font-weight: bold;
  font-size: 12px;
`;

const notificationOptions = { type: 'success', autoClose: 5000 };

const CsvDownloadButton = ({ csvLink, downloadBoxMargin }) => {
  const [csvVisibility, setCsvVisibility] = useState(false);

  const Button = () => {
    const csvOnClick = () => {
      toast('Your csv is processing...', notificationOptions);
      setCsvVisibility(!csvVisibility);
    };

    return (
      <CsvDownloadBox margin={downloadBoxMargin}>
        <CsvDownloadText href={csvLink} onClick={() => csvOnClick()}>
          Download CSV
        </CsvDownloadText>
      </CsvDownloadBox>
    );
  };

  return (
    <Fragment>
      <Icon
        type="ellipsis-v"
        color={Styles.colors.blue.secondaryDark}
        style={{ cursor: 'pointer' }}
        onClick={() => setCsvVisibility(!csvVisibility)}
      />
      {csvVisibility ? <Button csvLink={csvLink} /> : null}
    </Fragment>
  );
};

export default CsvDownloadButton;

CsvDownloadButton.propTypes = {
  csvLink: PropTypes.string.isRequired,
  downloadBoxMargin: PropTypes.string
};

CsvDownloadButton.defaultProps = {
  downloadBoxMargin: '1px'
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/CsvDownloadButton.jsx